import { Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../core/state';
import { User } from '../../../core/state/users/models';
import { Resource } from '../../../core/state/resource/models';

import * as UserActions from '../../../../shared/core/state/users/user.actions';
import {
  selectIsLoggedIn,
  selectUser,
} from '../../../core/state/users/user.selectors';

@Component({
  selector: 'black-auth-control',
  templateUrl: './auth-control.component.html',
  styleUrls: ['./auth-control.component.css'],
  standalone: false,
})
export class AuthControlComponent implements OnInit {
  private store = inject<Store<State>>(Store);

  isLoggedIn = false;
  loggedInUser: Partial<User> | null = null;

  ngOnInit(): void {
    this.store.select(selectIsLoggedIn).subscribe((loggedIn) => {
      this.isLoggedIn = loggedIn;
    });
    this.store.select(selectUser).subscribe((user) => {
      this.loggedInUser = user;
    });
  }

  get lastName() {
    return this.loggedInUser?.name?.lastName;
  }

  getAvatarUrl(avatar: Resource | undefined): string | null {
    return avatar?.path || null;
  }

  logout() {
    this.store.dispatch(UserActions.logout({ redirect: true }));
  }
}
